const IOS_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, interactive-widget=overlays-content';
const DEFAULT_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1.0, user-scalable=yes, viewport-fit=cover, interactive-widget=overlays-content';
const iosZoomLockedDocs = new WeakSet<Document>();

export const isIOSDevice = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
};

export const lockIOSZoom = (doc: Document = document) => {
  if (!isIOSDevice() || iosZoomLockedDocs.has(doc)) {
    return;
  }

  const preventGestureZoom: EventListener = (event) => {
    event.preventDefault();
  };
  const preventPinchTouchMove = (event: TouchEvent) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };

  doc.addEventListener('gesturestart', preventGestureZoom, { passive: false });
  doc.addEventListener('gesturechange', preventGestureZoom, { passive: false });
  doc.addEventListener('gestureend', preventGestureZoom, { passive: false });
  doc.addEventListener('touchmove', preventPinchTouchMove, { passive: false });

  iosZoomLockedDocs.add(doc);
};

/**
 * Sets the viewport meta tag based on the user agent.
 */
export const setViewport = () => {
  const existingViewport = document.querySelector('meta[name="viewport"]');
  const viewport = document.createElement('meta');

  if (existingViewport) {
    existingViewport.remove();
  }

  viewport.name = 'viewport';
  viewport.content = isIOSDevice() ? IOS_VIEWPORT_CONTENT : DEFAULT_VIEWPORT_CONTENT;
  document.head.appendChild(viewport);

  lockIOSZoom(document);
};
